import { SidebarMenu, SidebarMenuItem } from "../ui/sidebar";
import type { AdminWorkspace } from "./types";

export function TeamSwitcher({ workspace }: { workspace: AdminWorkspace }) {
  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <div className="flex min-h-12 w-full items-center gap-3 rounded-lg px-2 text-sidebar-foreground">
          <span
            className="grid aspect-square size-8 place-items-center rounded-lg bg-primary text-sm font-bold text-primary-foreground"
            aria-hidden="true"
          >
            W
          </span>
          <span className="grid min-w-0 flex-1 text-left text-sm leading-tight group-data-[collapsible=icon]:hidden">
            <strong className="truncate font-semibold">{workspace.name}</strong>
            <small className="truncate text-xs text-muted-foreground">
              {workspace.environment} · {workspace.currency}
            </small>
          </span>
        </div>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
